module.exports = __webpack_public_path__ + "img/home-main-banner.62567e09.png";